import { FeatureFlagFragment } from "../../../graphql/cms-types"


const mapFeatureFlags = (
  flags: FeatureFlagFragment[],
): Record<string, FeatureFlagFragment> => {
  const flagMap: Record<string, FeatureFlagFragment> = {}
  if (flags.length === 0) return flagMap

  flags.forEach(flag => {
    flagMap[flag.featureFlag] = flag
  })

  return flagMap
}

export default mapFeatureFlags
